export default "__VITE_ASSET__BKFi35fA__"